export const PaymentStatus = {
    REFUND: 'Refund',
    VOID: 'Void',
    PART_PAID: 'Part Paid',
    UNPAID: 'Unpaid'
};
